export default [
    'Date',
    'Offer Date',
    'Award Date',
    'Accepted Offer Date',
]